import { prepareMoviesData } from '../../utils/prepareMoviesData';
import { getMoviesJsonForEnUs } from '../../utils/getMoviesJsonForEnUs';
import frenchMoviesJSON from './frenchMovies.data.json';
import asterixObelixMissionCleopatreImageUrl from './assets/asterix-obelix-mission-cleopatre.jpg';
import bienvenueChezLesChTisImageUrl from './assets/bienvenue-chez-les-ch-tis.jpg';
import ernestEtCelestineImageUrl from './assets/ernest-et-celestine.jpg';
import intouchablesImageUrl from './assets/intouchables.jpg';
import intouchablesPreviewUrl from './assets/intouchables-preview.png';
import kirikouEtLaSorciereImageUrl from './assets/kirikou-et-la-sorciere.jpg';
import laFeeImageUrl from './assets/la-fee.jpg';
import laGrandeVadrouilleImageUrl from './assets/la-grande-vadrouille.jpg';
import laMarcheDeLEmpereurImageUrl from './assets/la-marche-de-l-empereur.jpg';
import leFabuleuxDestinDAmeliePoulainImageUrl from './assets/le-fabuleux-destin-d-amelie-poulain.jpg';
import leJouetImageUrl from './assets/le-jouet.jpg';
import lesVisiteursImageUrl from './assets/les-visiteurs.jpg';
import maPartDuGateauImageUrl from './assets/ma-part-du-gateau.jpg';
import oss117LeCaireNidDEspionsImageUrl from './assets/oss-117-le-caire-nid-d-espions.jpg';
import parisJeTAimeImageUrl from './assets/paris-je-t-aime.jpg';
import uneVieDeChatImageUrl from './assets/une-vie-de-chat.jpg';

const images = {
  posters: {
    'asterix-obelix-mission-cleopatre-2002': asterixObelixMissionCleopatreImageUrl,
    'bienvenue-chez-les-ch-tis-2008': bienvenueChezLesChTisImageUrl,
    'ernest-et-celestine-2012': ernestEtCelestineImageUrl,
    'intouchables-2011': intouchablesImageUrl,
    'kirikou-et-la-sorciere-1998': kirikouEtLaSorciereImageUrl,
    'la-fee-2011': laFeeImageUrl,
    'la-grande-vadrouille-1966': laGrandeVadrouilleImageUrl,
    'la-marche-de-l-empereur-2005': laMarcheDeLEmpereurImageUrl,
    'le-fabuleux-destin-d-amelie-poulain-2001': leFabuleuxDestinDAmeliePoulainImageUrl,
    'le-jouet-1976': leJouetImageUrl,
    'les-visiteurs-1993': lesVisiteursImageUrl,
    'ma-part-du-gateau-2011': maPartDuGateauImageUrl,
    'oss-117-le-caire-nid-d-espions-2006': oss117LeCaireNidDEspionsImageUrl,
    'paris-je-t-aime-2006': parisJeTAimeImageUrl,
    'une-vie-de-chat-2010': uneVieDeChatImageUrl,
  },
  previews: {
    'intouchables-2011': intouchablesPreviewUrl,
  },
};

export const frenchMovies = prepareMoviesData(frenchMoviesJSON, images);

export const frenchMoviesForEnUs = prepareMoviesData(
  getMoviesJsonForEnUs(frenchMoviesJSON),
  images,
);
